/** @format */
import { Market } from '@toucan/client/global/market';

import { getSearchResults } from '../requests';
import { Query, QueryResponse, SearchListingProduct } from '../types';
import { PRODUCT_FACET_FIELDS } from './constants';
import { getProductListingSortBy, getProductResultsRows } from './helpers';
import {
    getProductListingFacetsQuery,
    getProductSearchResultsQuery,
} from './queries';
import { ProductSearchParams } from './types';

type ModifierGroups = Parameters<typeof getProductSearchResultsQuery>[6];

export function fetchProductSearchResults(
    baseQuery: Partial<Query>,
    { pageIndex, filterQuery, sort }: ProductSearchParams,
    resultsPerPage: number,
    market: Market,
    modifierGroups?: ModifierGroups
): Promise<QueryResponse<SearchListingProduct>> {
    const query = getProductSearchResultsQuery(
        baseQuery,
        0,
        getProductResultsRows(pageIndex, resultsPerPage),
        filterQuery,
        getProductListingSortBy(sort),
        market.code,
        modifierGroups
    );

    return getSearchResults<SearchListingProduct>(
        query,
        market.iso,
        market.code
    );
}

export function fetchProductFacets(
    baseQuery: Partial<Query>,
    market: Market
): Promise<QueryResponse<SearchListingProduct>> {
    return getSearchResults<SearchListingProduct>(
        getProductListingFacetsQuery(
            baseQuery,
            market.code,
            PRODUCT_FACET_FIELDS
        ),
        market.iso,
        market.code
    );
}
